import React from "react";
import { CreditCard } from "lucide-react";
import { BANDEIRAS_CARTAO } from "../utils/cartaoBandeira";

const BandeiraCartao = ({ bandeira, size = "md" }) => {
  const info = bandeira ? BANDEIRAS_CARTAO[bandeira] : null;
  const cls = `cartao-bandeira cartao-bandeira--${size}${bandeira ? ` cartao-bandeira--${bandeira}` : " cartao-bandeira--generico"}`;

  if (!info) {
    return (
      <span className={cls} aria-hidden="true" title="Bandeira do cartão">
        <CreditCard size={size === "sm" ? 16 : 18} />
      </span>
    );
  }

  return (
    <span className={cls} aria-label={info.label} title={info.label}>
      {bandeira === "visa" && (
        <svg viewBox="0 0 48 16" aria-hidden="true">
          <text x="0" y="13" fill="currentColor" fontSize="14" fontWeight="800" fontFamily="Arial, sans-serif">
            VISA
          </text>
        </svg>
      )}
      {bandeira === "mastercard" && (
        <svg viewBox="0 0 32 20" aria-hidden="true">
          <circle cx="12" cy="10" r="8" fill="#EB001B" />
          <circle cx="20" cy="10" r="8" fill="#F79E1B" />
        </svg>
      )}
      {bandeira === "amex" && (
        <svg viewBox="0 0 52 16" aria-hidden="true">
          <text x="0" y="12" fill="currentColor" fontSize="10" fontWeight="800" fontFamily="Arial, sans-serif">
            AMEX
          </text>
        </svg>
      )}
      {bandeira === "elo" && (
        <svg viewBox="0 0 36 16" aria-hidden="true">
          <text x="0" y="13" fill="currentColor" fontSize="13" fontWeight="800" fontFamily="Arial, sans-serif">
            elo
          </text>
        </svg>
      )}
      {bandeira === "hipercard" && (
        <svg viewBox="0 0 72 16" aria-hidden="true">
          <text x="0" y="12" fill="currentColor" fontSize="9" fontWeight="800" fontFamily="Arial, sans-serif">
            HIPERCARD
          </text>
        </svg>
      )}
      {bandeira === "diners" && (
        <svg viewBox="0 0 64 16" aria-hidden="true">
          <text x="0" y="12" fill="currentColor" fontSize="9" fontWeight="800" fontFamily="Arial, sans-serif">
            DINERS
          </text>
        </svg>
      )}
    </span>
  );
};

export default BandeiraCartao;
